module.exports = __webpack_public_path__ + "static/media/back-to-home.8aa906c4.svg";